"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONSTANTS = void 0;
exports.CONSTANTS = {
    arcTooltipClassname: "gauge-component-arc-tooltip",
    tickLineClassname: "tick-line",
    tickValueClassname: "tick-value",
    valueLabelClassname: "value-text",
    debugTicksRadius: false,
    debugSingleGauge: false,
    rangeBetweenCenteredTickValueLabel: [0.35, 0.65]
};
exports.default = exports.CONSTANTS;
